namespace advisorop.services {
    `use strict`;

    export class CompanyGroupApi {

        readonly apiUrl = `/api/companygroup`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }
        

        getAdvisoryFirmsByCompanyGroup(companyGroupId: number): ng.IHttpPromise<Array<domains.IAdvisoryFirm>> {
            return this.$http.get(`${this.apiUrl}/${companyGroupId}/firms`);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service("companyGroupApi", CompanyGroupApi);
}